const customIdentifier = 'perspective_'

export default customIdentifier
